/* global $ */
/**
 * $.fn.selectText -> http://stackoverflow.com/a/40734974/201318
 * {{{
 */
$.fn.selectText = function() {
    this.find('input').each(function() {
        if ($(this).prev().length == 0 || !$(this).prev().hasClass('p_copy')) {
            $('<p class="p_copy" style="position: absolute; z-index: -1;"></p>').insertBefore($(this))
        }
        $(this).prev().html($(this).val())
    })
    var doc = document
    var element = this[0]
    if (doc.body.createTextRange) {
        var range = document.body.createTextRange()
        range.moveToElementText(element)
        range.select()
    } else if (window.getSelection) {
        var selection = window.getSelection()
        var range = document.createRange()
        range.selectNodeContents(element)
        selection.removeAllRanges()
        selection.addRange(range)
    }
}

/* }}} */




//////////////////
// WEBPACK FOOTER
// ./js/jquery.selectText.js
// module id = 23
// module chunks = 0